import logoImg from '@assets/images/logo.svg';
import { IconOutlineRefresh2 } from '@components/icons/outline';
import { Button } from '@components/ui';
import { captureException } from '@sentry/react';
import { ReactElement, useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

const CHUNK_ERROR_MSG = 'Failed to fetch dynamically imported module';

export default function ErrorBoundary(): ReactElement {
  const routeError = useRouteError() as Error;

  const isChunkError = routeError?.message?.includes(CHUNK_ERROR_MSG);

  const handleHardReload = () => {
    (window.location as any).reload(true);
  };

  useEffect(() => {
    if (!routeError || isChunkError) return;

    captureException(routeError, { level: 'fatal' });
  }, [routeError]);

  return (
    <main className="p-8 text-center ">
      <div className="py-2">
        <img
          className="mx-auto block h-10 xl:h-12"
          src={logoImg}
          alt="logo"
        />
      </div>

      <h1 className="mt-40 text-3xl font-extralight">
        Sorry, unexpected error happened!
        <br />
        Please try to refresh the page.
      </h1>

      <div className="mt-8">
        <Button
          size="lg"
          variant="toned"
          className="!font-bold"
          prependIcon={IconOutlineRefresh2}
          onClick={handleHardReload}
        >
          Refresh Page
        </Button>
      </div>
    </main>
  );
}
